import styled from "styled-components"
import {H3} from "@irati/ui/src//Typography/Heading"
import ThumbnailImage from "../styled/ThumbnailImage"

export const CenteredH3 = styled(H3)`
  text-align: center;
`

export const CenteredThumbnailImage = styled(ThumbnailImage)`
  height: 80px;
  width: 80px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: -40px;
`

export const DealDescriptionText = styled.div`
  word-wrap: break-word;
  overflow-y: auto;
  overflow-x: hidden;
  height: 220px;
`
